import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-placeholder',
  templateUrl: './placeholder.component.html',
  styleUrl: './placeholder.component.scss',
  standalone: false
})
export class PlaceholderComponent {
  @Input() text: string;
  @Input() height: string;
  @Input() iconClass?: string;
  @Input() inputClass?: string;
}
